<template>
    <div class="tmp">Bar plot to display the proportion of classified reads.<br/><br/><br/>Could be one pie (%classified, and blank/empty for the rest) per tool. <br/><br/><br/>https://echarts.apache.org/examples/en/editor.html?c=calendar-pie</div>
    <div></div>
    <br/>
</template>

<script>
export default {
  name: 'Classified',
  props: {
    instance: String,
    sample: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  display: inline;
  font-size:5vw;
  width:70%;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.tmp {
  background-color:#cccccc;
  color:white;
  height:24em;
}
</style>
